import "../utility/lang-switcher.js";
import "../utility/fullscreen.js";

var scroll_element = document.scrollingElement || document.documentElement;
var go_back_button = document.getElementById("go-back");
// in this project, go-top goes to the start(left)
var go_top_button = document.getElementById("go-top");
var imgs = document.getElementsByClassName('scroll-blur');

scroll_element.addEventListener("wheel", transformScroll);
scroll_element.addEventListener("scroll", transformScroll);

// go_back_button.herf = document.referrer;
// go_back_button.onclick = function() {
//     history.back();
//     return false;
// }

function transformScroll(event) {
    // only scroll horizontally
	if (!event.deltaY) {
		return;
	}
    event.currentTarget.scrollLeft += event.deltaY;
    // change color the go-back button
    if (event.currentTarget.scrollLeft >= 450) {
        go_back_button.style.color = "white";
    }else {
        go_back_button.style.color = "black";
    }
    // show go-top button
    if (event.currentTarget.scrollLeft > 300) {
		go_top_button.style.display = "block";
	} else {
		go_top_button.style.display = "none";
	}
    // blur image according to scroll
    let windowsCenter = window.innerWidth/2;
    for (var ind in imgs) {
        // if the image is out of the screen, do nothing
        if (!imgs[ind].getBoundingClientRect) {continue;}
        let imgCenter = imgs[ind].getBoundingClientRect().left + imgs[ind].clientWidth/2;
        let blurVal = Math.max(0, (Math.abs(imgCenter - windowsCenter) - 200) / 100);
        imgs[ind].style.filter = 'blur(' + blurVal + 'px)';
        imgs[ind].style.webkitfilter = 'blur(' + blurVal + 'px)';
    }
}

// go to the far left
document.querySelector('#go-top').addEventListener('click', topFunction);

function topFunction() {
    window.scroll({
        top: 0, 
        left: 0, 
        behavior: 'smooth'
      });
    go_back_button.style.color = "black";
}

